// extracted by mini-css-extract-plugin
export default {"picture":"Y5JSh_","labeled":"eFQXzJ","labeledThumbnail":"XSHq_U"};